import FirstPlaceThrophy from '~/assets/gamification/times-table-competition-2021/first-place'
import ParticipantThrophy from '~/assets/gamification/times-table-competition-2021/participant'
import SecondPlaceThrophy from '~/assets/gamification/times-table-competition-2021/second-place'
import ThirdPlaceThrophy from '~/assets/gamification/times-table-competition-2021/third-place'
import { Award } from '~/gamification/types/gamification.types'

export default function ChooseAward({ type }: { type: Award | undefined }): React.ReactElement {
  const className = `block mx-auto max-w-full`
  switch (type) {
    case Award.FIRST:
      return <img className={className} src={FirstPlaceThrophy} />
    case Award.SECOND:
      return <img className={className} src={SecondPlaceThrophy} />
    case Award.THIRD:
      return <img className={className} src={ThirdPlaceThrophy} />
    case Award.STANDARD:
      return <img className={className} src={ParticipantThrophy} />
    default:
      return <img className={`${className} brightness-0`} src={ParticipantThrophy} />
  }
}
